export default {
  instantReplyList: [],
  automationRules: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  messages: [],
  instantReply: {},
  replyStatistics: {
    total_delivered: 0,
    delivered_to: 0,
    total_clicked: 0,
    clicked_by: 0,
    links: [],
  },
  keywordAnalytics: {
    unique_interactions: {},
    all_interactions: {},
  },
  automationSettings: {},
  updatedAISchema: null,
  loadingInstantReplies: true,
  automationRulesLoaded: false,
  automationRuleSaved: false,
  automationRuleDeleted: false,
  instantReplySaved: false,
  instantReplyDeleted: false,
  instantReplyMessageDeleted: false,
  automationSettingsSaved: false,
  unsubscribeMessageSaved: false,
  uploadedFile: false,
  apiError: {},
  fileUploadError: {},
  backgroundActions: [],
  fileUploadCancelled: false,
  assistantDataSaved: {
    assistantId: null,
    timestamp: null,
  },
  scrapingStatus: {},
  updatedCounter: {},
  webScrapeCounter: {
    // '1a8ed4e1-933f-43dc-ba43-90b21a8a119d': {
    //   all: {
    //     all: 12345,
    //     current: 11211,
    //     percentage: 43,
    //   },
    //   specific: {
    //     all: 1235,
    //     current: 111,
    //     percentage: 9,
    //   },
    // },
  },
  webScrapeDeleteCounter: {
    // '1a8ed4e1-933f-43dc-ba43-90b21a8a119d': {
    //   all: {
    //     all: 125,
    //     current: 11,
    //     percentage: 8,
    //   },
    //   specific: {
    //     all: 125,
    //     current: 111,
    //     percentage: 88,
    //   },
    // },
  },
  fileChangesTracker: {
    filesAdded: 0,
    filesRemoved: 0,
  },
  /**
   *  Used to show the correct number on the file input button.
   * Should be reset when user navigates away from the page or when the assistant is updated.
   */
  tempFileCounter: {},
  fileUploadCounter: {
    // '1a8ed4e1-933f-43dc-ba43-90b21a8a119d': {
    //   all: 125,
    //   current: 11,
    //   percentage: 0,
    // },
  },
  fileDeleteCounter: {
    // '1a8ed4e1-933f-43dc-ba43-90b21a8a119d': {
    //   all: 125,
    //   current: 11,
    //   percentage: 0,
    // },
  },
  backgroundActionsStartedByUser: [],
  actionInProgress: {},
};
